<template>
  <!-- 填空或选词填空 -->
  <div>
    <!-- <div class="que_box" v-for="item in programmesArr" :key="item.orders"> -->
      <!-- 题干 -->
      <div>
        {{ item.orders }}、 <span v-html="item.titleHtml"></span> ({{
          item.score
        }}分)
      </div>
      <!-- 答案 -->
      <ul class="ans_ul" v-for="ans in item.programmes" :key="ans.orders">
        <li class="line">
          (空{{ ans.orders }})正确答案 <span></span> ：<span>{{
              ans.shortAnswersContent ? ans.shortAnswersContent : "无"
            }}</span>
        </li>
        <li class="line">
          (空{{ ans.orders }})考生作答 <span></span> ：<span
            :class="
              ans.shortAnswers &&
              ans.userAnswers &&
              compareAnswers(ans.shortAnswers, ans.userAnswers)
                ? 'green_font'
                : 'red_font'
            "
            >{{
              ans.userAnswersContent ? ans.userAnswersContent : "未作答"
            }}</span
          >
        </li>
      </ul>
      <!-- 教师评分： -->
      <ul class="teacher_score">
        <li>
          教师评分：
          <el-input
            style="width: 30%"
            type="number"
            v-model="item.teacherScore"
            @input="inputFunc(item.orders, item.teacherScore)"
          >
          </el-input>
          分
        </li>
        <li>
          教师评语：
          <el-input
            style="width: 86%"
            type="text"
            placeholder="请输入本题评语（可以留空）"
            v-model="item.comment"
            maxlength="100"
            show-word-limit
          >
          </el-input>
        </li>
      </ul>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "ProgrammesType",
  props: {
    // programmesArr: Array,
    item: Object,
    subjectType: Number,
  },
  created() {
    // this.programmesArr.forEach((item) => {
      this.item.titleHtml = this.item.titleHtml.replace(
        /<img/g,
        "<img style='width:80px;height:auto;'"
      );
      if (this.subjectType == 11) {
        this.item.programmes.forEach((sub) => {
          this.item.selects.forEach((option) => {
            if (sub.shortAnswers == option.prefix) {
              sub.shortAnswersContent = decodeURIComponent(option.contents);
            }
            if (sub.userAnswers == option.prefix) {
              sub.userAnswersContent = decodeURIComponent(option.contents);
            }
          });
        });
      } else {
        this.item.programmes.forEach((sub) => {
          sub.shortAnswersContent = sub.shortAnswers;
          sub.userAnswersContent = sub.userAnswers;
        });
      }
    // });
  },
  watch: {
    programmesArr: {
      handler(newValue) {
        this.$emit("change-programmes", newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 标准化答案字符串，移除特殊字符和空白
    normalizeAnswer(answer) {
      if (!answer) return '';
      return answer
        .replace(/<[^>]*>/g, '') // 移除HTML标签
        .toLowerCase() // 转换为小写
        .replace(/&nbsp;/g, ' ') // 替换HTML空格实体
        .replace(/&amp;/g, '&') // 替换HTML &实体
        .replace(/&lt;/g, '<') // 替换HTML <实体
        .replace(/&gt;/g, '>') // 替换HTML >实体
        .replace(/&quot;/g, '"') // 替换HTML "实体
        .replace(/&#39;/g, "'") // 替换HTML '实体
        .replace(/[\u200B-\u200D\uFEFF]/g, '') // 移除零宽字符
        .replace(/[\u0000-\u001F\u007F-\u009F]/g, '') // 移除其他控制字符
        .replace(/\s+/g, ' ') // 标准化空白字符
        .trim(); // 移除首尾空白
    },
    
    // 比较两个答案是否相等
    compareAnswers(answer1, answer2) {
      const normalized1 = this.normalizeAnswer(answer1);
      const normalized2 = this.normalizeAnswer(answer2);
      return normalized1 === normalized2;
    },
    
    inputFunc(index, val) {
      // 判断当前是哪个input输入框改变
      // this.programmesArr.map((item) => {
        if (this.item.orders == index) {
          if (val > this.item.score) {
            this.$alert(
              "亲:试题分数不能大于[试题满分]请重新评分！",
              "友情提示",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.item.teacherScore = 0;
                },
              }
            );
            return false;
          }
        }
      // });
    },
  },
};
</script>

<style scoped>
</style>